module.exports = __webpack_public_path__ + "img/personal_presentation.fcbedc1b.jpg";